import React, { ReactElement, useState, createContext } from 'react';
import SearchPanel from './SearchPanel/SearchPanel';
import CountriesListContainer from './CountriesList/CountriesListContainer';
import { CountryItem } from './data';

export const CountriesContext = createContext<any>({});

const Countries = (): ReactElement => {
  const [ foundTerms, setFoundTerms ] = useState<CountryItem[]>([]);
  const [ searchValue, setSearchValue ] = useState<string>('');
  const [ isSearchActive, setIsSearchActive ] = useState<boolean>(false);

  const contextValue = {
    foundTerms,
    setFoundTerms,
    searchValue,
    setSearchValue,
    isSearchActive,
    setIsSearchActive,
  };

  return (
    <section className="freight-forwarder__countries">
      <div className='container'>
        <h2 className="freight-forwarder__countries-title">All Freight Shipping</h2>
        <CountriesContext.Provider value={contextValue}>
          <SearchPanel/>
          <CountriesListContainer/>
        </CountriesContext.Provider>
      </div>
    </section>
  );
};

export default Countries;
